import axios from 'axios';
import * as endpoints from './const';

class CorporateQuoteApi {
  /**
   * fetch Questions
   */
  static getQuestions() {
    return axios
      .get(endpoints.CORPORATE_QUOTE_QUESTIONS)
      .then(response => response.data)
      .then(data => {
        return data.data;
      })
      .catch(error => {
        throw error;
      });
  }

  /**
   * fetch Vehicles
   */
  static getVehicles(answers) {
    return axios
      .post(endpoints.CORPORATE_QUOTE_VEHICLES, {
        Answers: answers,
      })
      .then(response => response.data)
      .then(data => {
        return data;
      })
      .catch(error => {
        throw error;
      });
  }

  /**
   * fetch Vehicles with session
   */
  static getVehiclesWithSession(sessionId) {
    const fullEndpoint = [
      endpoints.CORPORATE_QUOTE_VEHICLES,
      `?sessionId=${sessionId}`,
    ];
    return axios
      .get(fullEndpoint.join(''))
      .then(response => response.data)
      .then(data => {
        return data;
      })
      .catch(error => {
        throw error;
      });
  }

  /**
   * fetch vehicle options
   */
  static getOptions(quoteTemplateId, variantId) {
    return axios
      .get(
        `${endpoints.CORPORATE_QUOTE_OPTIONS}/${quoteTemplateId}/${variantId}`
      )
      .then(response => response.data)
      .then(data => {
        return data.data;
      })
      .catch(error => {
        throw error;
      });
  }

  /**
   * get addresses
   */
  static getAddresses(id) {
    return axios
      .get(`${endpoints.CORPORATE_QUOTE_GET_ADDRESSES}/${id}`)
      .then(response => response.data)
      .then(data => {
        return data.data;
      })
      .catch(error => {
        throw error;
      });
  }

  /**
   * get summary
   */
  static getSummary(quoteId, countryCode, companyCode) {
    return axios
      .get(endpoints.CORPORATE_QUOTE_SUMMARY, {
        params: { quoteId, countryCode, companyCode },
      })
      .then(response => response.data)
      .then(data => {
        return data.data;
      })
      .catch(error => {
        throw error;
      });
  }

  /**
   * export quote
   */
  static exportQuote(quoteId) {
    const windowReference = !window.navigator.msSaveBlob ? window.open() : null;
    return axios
      .get(`${endpoints.CORPORATE_QUOTE_EXPORT}/${quoteId}`, {
        responseType: 'blob',
      })
      .then(response => response.data)
      .then(data => {
        // http://stackoverflow.com/questions/21729451/pdf-blob-pop-up-window-not-showing-contnet/21730535#21730535
        // const file = new Blob([data], { type: 'application/pdf' });
        // IE workaround. createObjectURL not supported
        if (window.navigator.msSaveBlob) {
          window.navigator.msSaveBlob(data, quoteId);
        } else {
          const fileURL = URL.createObjectURL(data);
          windowReference.location = fileURL;
        }
      })
      .catch(error => {
        throw error;
      });
  }

  /**
   * submit quote
   */
  static submitQuote(QuoteId) {
    return axios
      .post(`${endpoints.CORPORATE_QUOTE_SUBMIT}`, { QuoteId })
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  /**
   * update quote
   */

  static updateQuote(payload) {
    return axios
      .post(`${endpoints.CORPORATE_QUOTE_UPDATE}`, payload)
      .then(response => response.data)
      .then(data => data.data)
      .catch(error => {
        throw error;
      });
  }

  static getQuotesApproval(payload) {
    return axios
      .get(endpoints.CORPORATE_QUOTE_GET_APPROVALS, { params: payload })
      .then(response => response.data)
      .then(data => data.data)
      .catch(error => {
        throw error;
      });
  }

  static getUserQuotes(payload) {
    return axios
      .get(endpoints.CORPORATE_QUOTE_GET_USER_QUOTES, { params: payload })
      .then(response => response.data)
      .then(data => data.data)
      .catch(error => {
        throw error;
      });
  }

  /**
   * get corportate quote summary approval
   */

  static getQuoteSummaryForApproval(quoteId) {
    return axios
      .get(`${endpoints.CORPORATE_QUOTE_SUMMARY_APPROVAL}?token=${quoteId}`)
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  /**
   * Resend quote approval email
   */
  static sendEmail(payload) {
    return axios
      .post(endpoints.CORPORATE_QUOTE_SEND_EMAIL, payload)
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  /**
   * Approve/Decline corportate quote summary
   */

  static approveQuoteSummaryForApproval(quoteId, decision, reason) {
    let endpointURL = '';

    //TODO referene the decision via the const reference-sriram
    if (decision === 2) {
      endpointURL = endpoints.CORPORATE_QUOTE_APPROVE;
    } else if (decision === 3) {
      endpointURL = endpoints.CORPORATE_QUOTE_DECLINE;
    }

    return axios
      .post(endpointURL, {
        token: quoteId,
        notes: reason,
      })
      .then(response => response.data)
      .then(data => {
        return data.data;
      })
      .catch(error => {
        throw error;
      });
  }
}

export default CorporateQuoteApi;



// WEBPACK FOOTER //
// ./src/api/CorporateQuoteApi.js